'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const SocialIcon = require('../../../global/components/SocialIcon');
const FacebookIcon = require('dibs-vg/dist/react/facebook');
const {trackFacebookSuccess, trackFacebookClick} = require('../../actions/pdpTrackingActions');
const hasContextTypes = require('../../../global/reactHelpers/hasContextTypes');

const PdpFacebookIcon = React.createClass(hasContextTypes({
    propTypes: {
        trackingSuffix: PropTypes.string,
        iconType: PropTypes.string
    },

    _handleClick() {

        // TODO: Maybe check for initialization.
        // TODO: Don't reference window here. Create a wrapper module instead.
        window.FB.ui({
            method: 'stream.share',
            u: window.document.location.href
        }, (response) => this.context.executeAction(trackFacebookSuccess, { response }));

        this.context.executeAction(trackFacebookClick, { suffix: this.props.trackingSuffix });
    },

    render() {
        const {iconType} = this.props;

        return (
            <SocialIcon onClick={this._handleClick} Icon={FacebookIcon} iconType={iconType} iconName="facebook" data-tn='facebook'/>
        );
    }

}));

module.exports = PdpFacebookIcon;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/social/PdpFacebookIcon.jsx